import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import UserRoles from "constants/UserRoles";

/**
 * @property {Manager_Tasks_Object} state
 * @property {object} model
 * @property {Manager_Tasks_Properties} model.properties
 *
 */

export default class ManagerTask extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Manager_Tasks._name);
		this.state.task_role = this.props.task_role;

	}

	form = () => {
		/**
		 * @param {Manager_Tasks_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Manager_Tasks_Object} object
		 */
		let object = this.state;
		return (
			<fieldset>
				<div className={'row'}>
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.title}
								value={object.title}
								error={object.title_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.description}
								value={object.description}
								error={object.description_error}
								update={this.handleTextFieldPropertyUpdate}
								multiline={4}
							/>
						</div>
					</div>
				</div>
			</fieldset>
		)
	}
}